import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { GOOGLE_MAPS_LOADER_OPTIONS } from "../utils/googleMaps";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

const MINI_MAP_OPTIONS = {
  disableDefaultUI: true,
  zoomControl: true,
  gestureHandling: "cooperative",
  keyboardShortcuts: false,
  clickableIcons: false,
};

export const MiniMap = ({ coords, label }) => {
  const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

  if (loadError || coords?.lat == null) return null;

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;

  return (
    <div className="relative mb-3 h-32 w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "100%" }}
          center={coords}
          zoom={12}
          options={MINI_MAP_OPTIONS}
        >
          <Marker position={coords} title={label || undefined} />
        </GoogleMap>
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-gray-100 dark:bg-gray-700/40">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-400 dark:border-gray-500" />
        </div>
      )}
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Open in Google Maps"
        className="absolute bottom-1.5 right-1.5 z-10 inline-flex items-center gap-1 rounded-md bg-white/90 dark:bg-gray-900/80 px-2 py-1 text-[11px] font-semibold text-gray-700 dark:text-gray-200 shadow-sm ring-1 ring-black/5 backdrop-blur-sm hover:bg-white dark:hover:bg-gray-900"
      >
        <ArrowTopRightOnSquareIcon className="h-3 w-3" />
        Open in Maps
      </a>
    </div>
  );
};
